import useEvent from '@react-hook/event';

export const useInvoiceRefetch = (refetch: () => Promise<Awaited<unknown>[]>) => {
  useEvent(window, 'PaymentComplete' as keyof WindowEventMap, () => refetch());
};
